import { render, staticRenderFns } from "./CompanyLabelsCpt.vue?vue&type=template&id=40c4953e&scoped=true&"
import script from "./CompanyLabelsCpt.vue?vue&type=script&lang=ts&"
export * from "./CompanyLabelsCpt.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyLabelsCpt.vue?vue&type=style&index=0&id=40c4953e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c4953e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VChip,VTooltip})
